import Alpine from 'alpinejs';
import priceChart from './content-modules/priceChart';
import { gtmPlatformLinkClicked } from './global/gtm';
import pressCarousel from './content-modules/pressCarousel';

const params = new URLSearchParams(window.location.search);
const code = params.get('code');
const codeIsSafe = Number.isInteger(Number.parseInt(code));
const buttons = document.querySelectorAll('a[href*="app.steelcoin.com/code"]');

code &&
  codeIsSafe &&
  buttons &&
  buttons.forEach((btn) => {
    btn.href = btn.href.endsWith('/') ? btn.href + code : btn.href + '/' + code;
  });

gtmPlatformLinkClicked();

Alpine.data('priceChart', priceChart);
Alpine.data('pressCarousel', pressCarousel);

window.Alpine = Alpine;
Alpine.start();
